import {IntroSlideShow} from "./IntroSlideShow";
import {
    GameIntroColors,
    GameIntroViewConfig,
    StampConfig, Volatility
} from "@nolimitcity/slot-keypad/bin/core/app/gameintro/GameIntroView";
import {ImgLoader} from "@nolimitcity/slot-keypad/bin/core/loaders/ImgLoader";
import {NolimitApplication} from "@nolimitcity/slot-keypad/bin/core/app/NolimitApplication";

export class DumpsterFireIntroConfig implements GameIntroViewConfig {

    colors: GameIntroColors = {
        slideShowColors: {
            backgroundColor: 0x000000, //Default 0x000000
            backgroundAlpha: 0, //Default 0.4
            bulletColor: 0xffffff, //Default 0xffffff

        },
        stampColor: 0xFFFFFF
    };

    stampConfig: StampConfig = {
        xWays: true,
        xWaysInfectious: true,
        xBet: true,
        volatility: Volatility.EXTREME
    };

    background: PIXI.Container;
    borderBottom: PIXI.Container;
    borderTop: PIXI.Container;
    logo: PIXI.Container;
    pages: IntroSlideShow[];

    constructor() {
    }

    public init(): Promise<GameIntroViewConfig> {
        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add("introBg", "resources/images/Intro_BG.jpg");
        imgLoader.add("introDiv", "resources/images/Intro_Divider.png");
        imgLoader.add("feature1", "resources/images/intro_feature1a.png");
        imgLoader.add("feature2", "resources/images/intro_feature2a.png");
        imgLoader.add("logo", "resources/images/introLogo.png");
        imgLoader.add("logo2", "resources/images/logo.png");
        return imgLoader.load().then(value => {
            this.initGraphics();
            return this;
        });
    }

    private initGraphics() {
        this.background = new PIXI.Container();
        const bgSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introBg"));
        bgSprite.anchor.set(0.5, 0.5);
        this.background.addChild(bgSprite);

        this.borderTop = new PIXI.Container();
        const topSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introDiv"));
        topSprite.anchor.set(0.5, 0.5);
        topSprite.visible = false;
        this.borderTop.addChild(topSprite);

        this.borderBottom = new PIXI.Container();
        const bottomSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introDiv"));
        bottomSprite.rotation = Math.PI;
        bottomSprite.anchor.set(0.5, 0.5);
        bottomSprite.visible = false;
        this.borderBottom.addChild(bottomSprite);

        this.logo = new PIXI.Container();
        const logoSprite = new PIXI.Sprite(ImgLoader.getImgTexture("logo"));
        logoSprite.anchor.set(0.5, 0.5);
        this.logo.addChild(logoSprite);

        const featureSprite1: PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture("feature1"));
        featureSprite1.anchor.set(0.5, 0.5);
        const featureSprite2: PIXI.Sprite = new PIXI.Sprite(ImgLoader.getImgTexture("feature2"));
        featureSprite2.anchor.set(0.5, 0.5);

        this.pages = [
            new IntroSlideShow(ImgLoader.getImgTexture("feature1"), false),
            new IntroSlideShow(ImgLoader.getImgTexture("feature2"), true)
        ];

        this.pages[0].addChild(featureSprite1);
        this.pages[1].addChild(featureSprite2);
    }
}